import CloseIcon from "@mui/icons-material/Close";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { CircularProgress, capitalize } from "@mui/material";
import type { DiscoveryRunState } from "../types";
import { StatusChip, type StatusEntry } from "./ui/status-chip";

const STATUS_MAP: Partial<Record<DiscoveryRunState, StatusEntry>> = {
  pending: {
    icon: <CircularProgress size={12} color="inherit" />,
    color: "secondary",
  },
  waiting: {
    icon: <CircularProgress size={12} color="inherit" />,
    color: "secondary",
  },
  running: {
    icon: <CircularProgress size={12} color="inherit" />,
    color: "info",
  },
  user_input_needed: {
    icon: <CircularProgress size={12} color="inherit" />,
    color: "secondary",
  },
  done: { icon: <DoneAllIcon sx={{ fontSize: 12 }} />, color: "success" },
  cancelled: {
    icon: <DoDisturbIcon sx={{ fontSize: 12 }} />,
    color: "warning",
  },
  closed: { icon: <CloseIcon sx={{ fontSize: 12 }} />, color: "primary" },
};

const formatLabel = (s: string) => capitalize(s.replace(/_/g, " "));

type Props = {
  state: DiscoveryRunState;
  variant?: "outlined" | "filled";
  size?: "small" | "medium";
};

export const DiscoveryRunStateChip: React.FC<Props> = ({
  state,
  variant = "outlined",
  size = "small",
}) => (
  <StatusChip
    status={state}
    statusMap={STATUS_MAP}
    formatLabel={formatLabel}
    variant={variant}
    size={size}
  />
);
